import TransportationPageContainer from './TransportationPageContainer';

export default TransportationPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/TransportationPage/index.js